// Une seule expression `import()` par route d'entité, partagée par `Routes.js`
// (`React.lazy`) et par le préchargement au repos (`prefetchWelfareRoutes`).
//
// Webpack découpe par expression `import()` : deux expressions visant le même
// module, écrites dans deux fichiers dont les chunks parents diffèrent, peuvent
// donner deux chunks distincts (mesuré le 22/09/2026 : la route individu existait
// en 747 Ko et 671 Ko bruts, le préchargement téléchargeait celui que la
// navigation n'utilisait pas). Une expression unique garantit un seul chunk.
//
// Ce module n'a aucun import statique : il reste dans le bundle principal sans
// y tirer `navigation-v2`.
export const welfareEntityRouteLoaders = Object.freeze({
  "collection.enclosures": () => import("../../enclosures-v2/app/EnclosuresRoute"),
  "collection.sector": () => import("../../sector-v2/app/SectorWorkspaceRoute"),
  "collection.individual": () => import("../../individual-detail-v2/app/IndividualDetailRoute"),
  "collection.groups": () => import("../../groups-v2/app/GroupsRoute"),
  "collection.sectors": () => import("../../sector-list-v2/app/SectorListRoute"),
  "collection.individuals": () => import("../../individuals-v2/app/IndividualsRegistryEntry"),
  // Tournées (liste et fiche, une seule route) : jamais préchargées jusqu'au 14/10, leur première
  // ouverture attendait le chunk après le clic.
  "operations.tours": () => import("../../tours-v2/app/ToursRoute"),
});

export default welfareEntityRouteLoaders;
